import { WORKSPACE_USER_FRAGMENT } from 'features/globalSetup/api/fragments/workspaceUser'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_USER: TypedDocumentNode<Data, Variables> = gql`
  ${WORKSPACE_USER_FRAGMENT}

  query getWorkspaceUser($id: ID!) {
    node(id: $id) {
      ... on User {
        ...WorkspaceUserFragment
      }
    }
  }
`
